import Sparkles from "../../../../components/Sparkles/Sparkles";
import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  Group,
  NumberInput,
  Popover,
  Stack,
  Text,
  Textarea,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBaselineDensityMedium, IconSparkles } from "@tabler/icons-react";
import { useState } from "react";
import GlobalLanguageSelector from "../../../../components/Selectors/GlobalLanguageSelector";
import { useLanguage } from "../../../../stores/LanguageStore";
import TemperatureSlider from "../../../../components/View/TemperatureSlider";
import { generatePrmReply } from "../../../../api/ModelsApi";
import { useLeadsSheetStore } from "../../../../stores/LeadsStore";

const ReplyGenerator = ({
  replyId,
  style,
  disabled,
  defaultPrompt,
  onFinish,
  isLinkedin,
}) => {
  const lang = useLanguage((s) => s.language);
  const [prompt, setPrompt] = useState(defaultPrompt || "");
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const current = useLeadsSheetStore((s) => s.current);

  const handleGenerate = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);

    generatePrmReply({
      reply_id: replyId,
      history_type_reply: isLinkedin ? "linkedin" : "email",
      contact_id: current.id,
      prompt: prompt,
      language: data?.language,
      number_paragraphs: parseInt(data?.paragraphs || 4),
      temperature: parseFloat(data.temperature),
    })
      .then((response) => {
        let generatedHtml = response.data.content;
        close();
        onFinish(generatedHtml);
      })
      .finally(() => setLoading(false));

    e.stopPropagation();
  };

  return (
    <Popover
      trapFocus
      shadow="sm"
      withArrow
      opened={opened}
      onClose={close}
      onOpen={open}
      zIndex={900}
    >
      <Popover.Target>
        <Tooltip label={lang.models.generator_reply.text}>
          <Box style={style} onClick={disabled ? null : open}>
            <Sparkles>
              <Button
                leftSection={<IconSparkles size={16} fill="#fcfbff" />}
                variant="gradient"
                disabled={disabled}
                size="sm"
                h={30}
                radius={"md"}
              >
                {lang.models.generator_reply.label}
              </Button>
            </Sparkles>
          </Box>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack
          component={"form"}
          onSubmit={handleGenerate}
          w={400}
          gap={6}
          pos={"relative"}
          id="ai-form"
        >
          <CloseButton pos={"absolute"} top={0} right={0} onClick={close} />
          <Text>{lang.models.generator_reply.text}</Text>
          <Textarea
            required
            value={prompt}
            placeholder={lang.models.generator_reply.placeholder}
            onChange={(e) =>
              1000 - prompt.length > 0 ? setPrompt(e.target.value) : null
            }
            label="Prompt"
            description={1000 - prompt.length + lang.global.char_remaining}
            rows={4}
            data-autofocus
          />
          <Group mt={"sm"}>
            <GlobalLanguageSelector
              noLabel
              name={"language"}
              withinPortal={false}
            />
            <NumberInput
              name="number_paragraphs"
              defaultValue={3}
              leftSection={
                <Tooltip label={lang.model_emails.create.dialog.paragraphs}>
                  <IconBaselineDensityMedium size={16} />
                </Tooltip>
              }
              w={75}
              size="xs"
              mr={"auto"}
              min={1}
              max={4}
            />

            <TemperatureSlider sm />
          </Group>

          <Group justify="end" mt={"sm"}>
            <Button
              leftSection={<IconSparkles size={18} />}
              type="submit"
              form="ai-form"
              loading={loading}
            >
              {lang.models.generator_reply.generate}
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default ReplyGenerator;
